export const hasArrayValues = (list) => !!list && Array.isArray(list) && list.length > 0;